import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as ErrorIcon } from 'src/assets/images/error.svg';
import { Black1, Black2, Grey, MangoAnotherBlue } from 'src/styles/colours';
import { DemiBold } from 'src/styles/fonts';
import styled from 'styled-components';

const StyledErrorContainer = styled.section`
  display: flex;
  height: 60%;
  justify-content: center;
`;

const StyledIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledHeading = styled.h1`
  font-family: ${DemiBold};
  font-size: 2rem;
  margin: 2rem 0 1rem 0;
  color: ${Black1};
`;

const StyledText = styled.span`
  color: ${Black2};
`;

const StyledBackButton = styled.button`
  font-family: ${DemiBold};
  border: 1px solid ${Grey};
  border-radius: 3px;
  color: ${MangoAnotherBlue};
  background: transparent;
  padding: 0.75rem 2rem;
  margin-right: 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
`;

export const Error: FC<{
  heading?: string;
  text?: string;
  showButton?: boolean;
}> = ({
  heading = 'Something went wrong',
  text = 'Please go back to the previous page or try again later',
  showButton = true,
}) => {
  const history = useHistory();
  return (
    <StyledErrorContainer>
      <StyledIconContainer>
        <ErrorIcon />
        <StyledHeading>{heading}</StyledHeading>
        <StyledText>{text}</StyledText>
        {showButton && (
          <StyledBackButton
            onClick={() => {
              history.goBack();
            }}
          >
            Go back
          </StyledBackButton>
        )}
      </StyledIconContainer>
    </StyledErrorContainer>
  );
};
